var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section-component',{attrs:{"body":_vm.page.body,"programma":_vm.programma,"hero":_vm.page.image,"header":_vm.page.image_text}}),_vm._v(" "),_c('search-component',{attrs:{"programma":_vm.programma}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }